/*
 * deepLinking Actions
 *
 * @version 1.0.0
 * @author Patrizia Petrera
 * @since 27-Feb-2025
 */

import { /* createRequestTypes, */ createAction/*, MakeRequest */ } from './index'

export const actionTypes = {
  DO_HANDLE_DEEP_LINKING: '@@deepLinking/handle_deep_linking'
  // @generator action:type
  // @generator action:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:request

/** @action
 * * Insert a description
 * @name HandleDeepLinking
 * @return {object} - The payload object
 */
export const doHandleDeepLinking = (payload, otherParams) => createAction(actionTypes.DO_HANDLE_DEEP_LINKING, { payload, otherParams })

// @generator action
